// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-age {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page-age .page-title {
  font-size: 34px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
}

.page-age .page-description {
  margin-bottom: 40px;
}

.page-age .description {
  font-size: 15px;
  font-weight: 700;
  color: var(--dark-gray);
}
.page-age .description span {
  font-weight: 300;
}

.page-age .survey-options-container {
  padding-bottom: 40px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 327px;
  gap: 0;
}

/* desktop */
@media (min-width: 1280px) {
  .page-age .survey-options-container {
    flex-wrap: nowrap;
    min-width: 656px;
    max-width: none;
  }
}

.page-age .survey-option {
  margin-bottom: 20px;
  --border-width: 1px;
  width: 156px;
  max-width: 156px;
  max-height: none;
  height: 152px;
  min-height: 152px;
  flex-grow: 1;
  padding: 0;
  flex-direction: column;
  border: var(--border-width) solid var(--main-highlight-color);
  background-color: var(--light-gray);
}

/* desktop */
@media (min-width: 1280px) {
  .page-age .survey-option {
    height: 192px;
    min-height: 192px;
  }
}

.page-age .survey-option.selected:hover {
  --border-width: 2px;

  border-color: var(--orange);
}

.page-age .survey-option img {
  position: absolute;
  width: 156px;
  height: 160px;
  top: -10px;
  left: 0;
  transition: top 0.1s;
  -webkit-transition: top 0.1s;
}

.page-age .survey-option:hover img {
  top: -18px;
}

.page-age .survey-option .content {
  z-index: 1; /* to be on top of the image */
  margin-top: auto;
  min-height: 28px;
  width: 100%;
  text-align: center;
  background-color: var(--gray);
  color: white;
  border-bottom-left-radius: calc(var(--survey-option-radius) - var(--border-width));
  border-bottom-right-radius: calc(var(--survey-option-radius) - var(--border-width));
  justify-content: center;
}

.page-age .survey-option.selected .content {
  background-color: var(--orange);
  color: var(--white);
}

.page-age .survey-option.selected .content .title {
  color: var(--white);
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/age.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;AACR;;AAEA,YAAY;AACZ;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,6DAA6D;EAC7D,mCAAmC;AACrC;;AAEA,YAAY;AACZ;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;;EAEnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,OAAO;EACP,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU,EAAE,8BAA8B;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,kFAAkF;EAClF,mFAAmF;EACnF,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".page-age {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.page-age .page-title {\n  font-size: 34px;\n  font-weight: 700;\n  line-height: 40px;\n  text-align: center;\n}\n\n.page-age .page-description {\n  margin-bottom: 40px;\n}\n\n.page-age .description {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--dark-gray);\n}\n.page-age .description span {\n  font-weight: 300;\n}\n\n.page-age .survey-options-container {\n  padding-bottom: 40px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  max-width: 327px;\n  gap: 0;\n}\n\n/* desktop */\n@media (min-width: 1280px) {\n  .page-age .survey-options-container {\n    flex-wrap: nowrap;\n    min-width: 656px;\n    max-width: none;\n  }\n}\n\n.page-age .survey-option {\n  margin-bottom: 20px;\n  --border-width: 1px;\n  width: 156px;\n  max-width: 156px;\n  max-height: none;\n  height: 152px;\n  min-height: 152px;\n  flex-grow: 1;\n  padding: 0;\n  flex-direction: column;\n  border: var(--border-width) solid var(--main-highlight-color);\n  background-color: var(--light-gray);\n}\n\n/* desktop */\n@media (min-width: 1280px) {\n  .page-age .survey-option {\n    height: 192px;\n    min-height: 192px;\n  }\n}\n\n.page-age .survey-option.selected:hover {\n  --border-width: 2px;\n\n  border-color: var(--orange);\n}\n\n.page-age .survey-option img {\n  position: absolute;\n  width: 156px;\n  height: 160px;\n  top: -10px;\n  left: 0;\n  transition: top 0.1s;\n  -webkit-transition: top 0.1s;\n}\n\n.page-age .survey-option:hover img {\n  top: -18px;\n}\n\n.page-age .survey-option .content {\n  z-index: 1; /* to be on top of the image */\n  margin-top: auto;\n  min-height: 28px;\n  width: 100%;\n  text-align: center;\n  background-color: var(--gray);\n  color: white;\n  border-bottom-left-radius: calc(var(--survey-option-radius) - var(--border-width));\n  border-bottom-right-radius: calc(var(--survey-option-radius) - var(--border-width));\n  justify-content: center;\n}\n\n.page-age .survey-option.selected .content {\n  background-color: var(--orange);\n  color: var(--white);\n}\n\n.page-age .survey-option.selected .content .title {\n  color: var(--white);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
